import { ColumnType, defaultSupportedColumnTypes } from 'app/shared/utils/column-type.util';
import { autoTableCreationMetadata, maxConcurrentConnectionsMetadata, preCopyScriptMetadata, queryTimeoutMetadata } from '../consts/metadata-consts';
import { Constants } from 'app/shared/shared-constants';
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { format } from 'app/shared/utils/string.util';

import { SqlPoolTableDataset } from 'app/model/dataset/sql-pool-table.dataset';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const sqlPoolDatasetMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(SqlPoolTableDataset).name,
    supportLinkedServiceTypes: [adfModelTypeMap.sqlPool.connectionType],
    displayName: stringResources.AzureSQLAnalyticsPool_DisplayText,
    tooltip: stringResources.AzureSQLDedicatedPool_Tooltip,
    datasetKind: 'table',
    isSource: true,
    isSink: true,
    icon: {
        className: 'svg-i-100x100-SQLPool'
    },
    supportAutoTableCreation: true,
    isFirstClass: true,
    supportGetMetadataActivity: true,
    supportDataTypes: defaultSupportedColumnTypes.concat(ColumnType.Date),
    isDataflowCompatible: true,
    supportCreatedAsV2: true,
    splitTablePath: true,
    category: ['Azure'],
    copySourceControls: [queryTimeoutMetadata],
    copySinkControls: [
        autoTableCreationMetadata(true),
        preCopyScriptMetadata(),
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'writeBatchTimeout',
                label: stringResources.ModelName_WriteBatchTimeout,
                validators: [
                    {
                        type: 'pattern',
                        pattern: Constants.timeoutValidationPattern,
                        errorMessage: format(stringResources.InvalidTimeoutPattern, stringResources.ModelName_WriteBatchTimeout)
                    }
                ]
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'writeBatchSize',
                label: stringResources.ModelName_WriteBatchSize,
                inputType: 'number',
                min: 0
            },
            dynamicContentTextClass: 'input-spaced'
        },
        maxConcurrentConnectionsMetadata
    ],
    PhysicalToLogicalMapping: {
        bit: ColumnType.Boolean,
        int: ColumnType.Int32,
        smallint: ColumnType.Int16,
        tinyint: ColumnType.Byte,
        bigint: ColumnType.Int64,
        smallmoney: ColumnType.Decimal,
        money: ColumnType.Decimal,
        real: ColumnType.Single,
        float: ColumnType.Single,
        binary: ColumnType.ByteArray,
        varbinary: ColumnType.ByteArray,
        char: ColumnType.String,
        nchar: ColumnType.String,
        varchar: ColumnType.String,
        nvarchar: ColumnType.String,
        date: ColumnType.DateTime,
        datetime: ColumnType.DateTime,
        datetime2: ColumnType.DateTime,
        smalldatetime: ColumnType.DateTime,
        time: ColumnType.TimeSpan,
        datetimeoffset: ColumnType.DateTimeOffset,
        decimal: ColumnType.Decimal,
        numeric: ColumnType.Decimal,
        uniqueidentifier: ColumnType.Guid,
        image: ColumnType.ByteArray,
        rowversion: ColumnType.ByteArray,
    }
};
